import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { SketchPicker } from 'react-color';
import i18n from 'i18next';
import RaisedButton from 'material-ui/RaisedButton';
import styles from '../../../styles/styles';
import style from './ReportForm.css';
import { renderNumberField, renderTextField } from '../../../services/form';
import withTranslation from '../../../hoc/withTranslation';

const validate = values => {
    const errors = {};
    const requiredFields = [
        'name',
    ];

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = i18n.t('generic.required');
        }
    });

    const color = values['color'];
    if (color && /(^#[0-9a-fA-F]{6}$)|(^#[0-9a-fA-F]{3}$)/i.test(color) === false) {
        errors['color'] = i18n.t('page_app.wrong_primary_color');
    }

    return errors;
};

export class ReportForm extends React.Component {

    static propTypes = {
        onFormReset: PropTypes.func
    };

    state = {
        displayColorPicker: false,
        color: undefined
    };

    // Handlers

    handleColorChangedFromField = (event) => {
        this.setState({ color: event.target.value });
    };

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker });
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false });
    };

    handleChange = (color) => {
        this.props.change('color', color.hex);
    };

    // Render

    render() {
        const {
            handleSubmit,
            pristine,
            reset,
            submitting
        } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div>
                    <Field
                        id="name"
                        name="name"
                        component={renderTextField}
                        label={this.props.t('generic.name')}
                        fullWidth={true}
                    />
                    <Field
                        id="color"
                        name="color"
                        component={renderTextField}
                        label={this.props.t('generic.color')}
                        fullWidth={true}
                        onChange={this.handleColorChangedFromField}
                        onClick={this.handleClick}
                    />
                    {this.state.displayColorPicker && (
                        <div style={style.popover}>
                            <div style={style.cover} onClick={this.handleClose} />
                            <SketchPicker color={this.state.color} onChange={this.handleChange} />
                        </div>
                    )}
                    <Field
                        id="display_order"
                        name="display_order"
                        component={renderNumberField}
                        label={this.props.t('generic.display_order')}
                        fullWidth={true}
                        type="number"
                        inputMode="numeric"
                        parse={(val) => parseInt(val, 10)}
                    />
                    {/*<BlockPicker onChange={this.handleChange}/>*/}
                </div>
                <div style={styles.formButtons}>
                    <RaisedButton
                        style={styles.formButton}
                        label={this.props.t('generic.save')}
                        disabled={submitting || pristine}
                        type="submit"
                        primary={true}
                    />
                    <RaisedButton
                        style={styles.formButton}
                        label={this.props.t('generic.reset')}
                        type="button"
                        disabled={pristine || submitting}
                        onClick={() => {
                            reset();
                            if (this.props.onFormReset) {
                                this.props.onFormReset();
                            }
                        }}
                    />
                </div>
            </form>
        );
    }
}

export default reduxForm({
    form: 'editReport',
    validate,
})(withTranslation(ReportForm));



// WEBPACK FOOTER //
// src/components/report/ReportForm/ReportForm.js